<div class="py-3 w-100 d-flex justify-content-between">
  <div class="list-header">
    <div class="nav-header__text">{{headerTitle}}</div>
  </div>
</div>
